import { createFeatureSelector, createSelector } from "@ngrx/store";
import { DisclosureLoginState } from "./disclosure-login.reducers";

// First selector complete
export const selectDisclosureLoginState =
    createFeatureSelector<DisclosureLoginState>('Disclosure Content');

const disclosureLoginContent = (data: DisclosureLoginState): string => data?.disclosure?.disclosureContent || '';

export const disclosureLoginContentSelector = createSelector(
    selectDisclosureLoginState,
    disclosureLoginContent
);

export const selectDisclosureLoginLoading = createSelector(
    selectDisclosureLoginState,
    (state) => state.loading
);

export const selectDisclosureLoginError = createSelector(
    selectDisclosureLoginState,
    (state) => state.error
)

export const selectBackChangeSubmittingSuccess = createSelector(
    selectDisclosureLoginState,
    (state) => state.isSubmittingSuccess
);
